import { AxiosResponse } from "axios";
import React, { useState } from "react";
import { UseMutationResult } from "react-query";
import { useAppSelector } from "../../hooks";
import useLogin from "../../hooks/useLogin";
import { LoginInfo } from "../../types";

const LoginForm: React.FC = () => {
    const memName = useAppSelector(state => state.auth.memName);
    const memKey = useAppSelector(state => state.auth.memKey);
    const [pwd, setPwd] = useState<string>('');
    const mutation: UseMutationResult<AxiosResponse, Error, LoginInfo> = useLogin();
    const memInfo: LoginInfo = {
        memName: '',
        memPass: '',
        memKey: '',
    }
    const handleCheckLogin = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        console.log(`memName: ${memName}, pwd: ${pwd}, memId: ${memKey}`);
        memInfo.memName = memName;
        memInfo.memPass = pwd;
        memInfo.memKey = memKey;
        mutation.mutate(memInfo);
    }

    const handlePwdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPwd(e.target.value);
    }
    
    return (
        <fieldset>
            <dl>
                <dt><label>이름</label></dt>
                <dd><input type="text" title="아이디" defaultValue={memName} style={{backgroundColor: "#f1ebeb"}} /></dd>
                <dt><label>비밀번호</label></dt>
                <dd><input type="password" value={pwd} onChange={handlePwdChange} title="비밀번호" /></dd>
            </dl>
            <button type="button" onClick={handleCheckLogin}>확인</button>
        </fieldset>
    )
}

export default LoginForm;